// Contains functions to create plot data.
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ChartAxisFormat: function() {
        return ChartAxisFormat;
    },
    defaultColors: function() {
        return defaultColors;
    },
    convertFromDataframe: function() {
        return convertFromDataframe;
    },
    ConvertData: function() {
        return ConvertData;
    },
    mainChartOptions: function() {
        return mainChartOptions;
    },
    SummaryChartOptions: function() {
        return SummaryChartOptions;
    },
    internals: function() {
        return internals;
    },
    getTraceColor: function() {
        return getTraceColor;
    }
});
const _const = require("../const/const");
const defaultColors = [
    '#e36041',
    '#3fab46',
    '#ad32ad',
    '#6264bc',
    '#32add1',
    '#e36992',
    '#ffad32',
    '#84bb32',
    '#c65757',
    '#5a82aa',
    '#ad69ad',
    '#4ebbad',
    '#bbbb40',
    '#845bd6',
    '#eb8f32',
    '#5b84d6',
    '#a23838',
    '#5aa781',
    '#5574A6',
    '#3B3EAC'
];
var ChartAxisFormat;
(function(ChartAxisFormat) {
    ChartAxisFormat[ChartAxisFormat["Commit"] = 0] = "Commit";
    ChartAxisFormat[ChartAxisFormat["Date"] = 1] = "Date";
})(ChartAxisFormat || (ChartAxisFormat = {}));
const convertFromDataframe = (df, domain = 'commit', traceKey)=>{
    var _df_header, _df, _df_header1;
    if ((((_df = df) === null || _df === void 0 ? void 0 : (_df_header = _df.header) === null || _df_header === void 0 ? void 0 : _df_header.length) || 0) === 0) {
        return null;
    }
    if (traceKey && !(traceKey in df.traceset)) {
        return null;
    }
    const keys = traceKey ? [
        traceKey
    ] : Object.keys(df.traceset);
    const firstRow = [];
    if (domain === 'commit' || domain === 'both') {
        firstRow.push({
            type: 'number',
            role: 'domain',
            label: 'Commit Position'
        });
    }
    if (domain === 'date' || domain === 'both') {
        firstRow.push({
            type: 'date',
            role: 'domain',
            label: 'Date'
        });
    }
    keys.forEach((k)=>firstRow.push({
            type: 'number',
            label: k
        }));
    const rows = [
        firstRow
    ];
    (_df_header1 = df.header) === null || _df_header1 === void 0 ? void 0 : _df_header1.forEach((column, idx)=>{
        const row = [];
        if (domain === 'commit' || domain === 'both') {
            row.push(column.offset);
        }
        if (domain === 'date' || domain === 'both') {
            row.push(new Date(column.timestamp * 1000));
        }
        keys.forEach((k)=>{
            const val = df.traceset[k][idx];
            row.push(val === _const.MISSING_DATA_SENTINEL ? null : val);
        });
        rows.push(row);
    });
    return rows;
};
function ConvertData(chartData) {
    /*
    The data in the plot needs to be in the following format.
    [
      [x-axis_label, line1_label, line2_label, ...],
      [x_value, line1_value, line2_value, ...], // first point
      [x_value, line1_value, line2_value, ...], // second point
      ...
      ...
    ]
  */ const columns = [
        chartData.xLabel
    ];
    const lineKeys = Object.keys(chartData.lines);
    lineKeys.forEach((key)=>{
        columns.push(key);
    });
    // The first row needs to be the column names
    const rows = [
        columns
    ];
    const rowCount = chartData.lines[lineKeys[0]].length;
    for(let i = 0; i < rowCount; i++){
        // Add the xValue which is the same for all lines
        const row = [
            chartData.lines[lineKeys[0]][i].x
        ];
        lineKeys.forEach((key)=>{
            // For each line, add the y value for datapoint at index i.
            row.push(chartData.lines[key][i].y);
        });
        rows[i + 1] = row;
    }
    return rows;
}
function mainChartOptions(style, domain, yAxis, showZero = false) {
    // The X axis can support either commit, or dates. Change the format
    // based on the current chart's format.
    const gridlineColor = style.getPropertyValue('--md-sys-color-inverse-on-surface');
    const minAxisValue = showZero ? 0 : undefined;
    const format = domain === 'commit' ? '#' : 'M/d/yy';
    return {
        // interpolateNulls will continue a line from the last known point to the
        // next available if there's nulls inbetween.
        interpolateNulls: true,
        // selectionMode multiple allows you to select multiple points on a plot.
        // we are going to only allow single so that on selection over an area, we
        // can estimate the delta range. note that the default is single.
        selectionMode: 'single',
        // https://developers.google.com/chart/interactive/docs/gallery/areachart
        // Defines how multiple data selections are rolled into the tooltip.
        // for selectionMode: single, this should be none, such that we only allow
        // one tooltip per seelction
        aggregationTarget: 'none',
        annotations: {
            style: 'line'
        },
        tooltip: {
            trigger: 'none'
        },
        pointSize: 3,
        dataOpacity: 0.7,
        titleTextStyle: {
            color: style.color
        },
        hAxis: {
            titleTextStyle: {
                color: style.getPropertyValue('--plot-axes-title-color')
            },
            textPosition: 'out',
            textStyle: {
                color: style.color
            },
            gridlines: {
                color: gridlineColor
            },
            minorGridlines: {
                color: gridlineColor
            },
            format: format
        },
        vAxis: {
            minValue: minAxisValue,
            title: yAxis,
            titleTextStyle: {
                color: style.getPropertyValue('--plot-axes-title-color')
            },
            textPosition: 'out',
            textStyle: {
                color: style.color
            },
            gridlines: {
                color: gridlineColor
            },
            minorGridlines: {
                color: gridlineColor
            },
            viewWindowMode: 'maximized'
        },
        // define clearance to prevent axis labels and data from getting clipped
        chartArea: {
            left: 120,
            right: 10,
            top: 5,
            bottom: 25
        },
        colors: defaultColors,
        legend: {
            position: 'none'
        },
        backgroundColor: style.getPropertyValue('--plot-background-color-sk'),
        series: {},
        crosshair: {
            trigger: 'both',
            focused: {
                opacity: 0.5
            }
        }
    };
}
function SummaryChartOptions(style, domain) {
    const format = domain === 'commit' ? '#' : 'MMM dd, yy';
    return {
        interpolateNulls: true,
        curveType: 'function',
        hAxis: {
            textPosition: 'out',
            textStyle: {
                color: style.color,
                fontSize: 8
            },
            gridlines: {
                count: 10
            },
            format: format
        },
        vAxis: {
            textPosition: 'out',
            gridlines: {
                color: 'transparent'
            },
            viewWindowMode: 'maximized'
        },
        tooltip: {
            trigger: 'none'
        },
        chartArea: {
            width: '100%',
            bottom: 25,
            top: 0,
            backgroundColor: {
                stroke: 'black',
                strokeWidth: 1
            }
        },
        // this value is inherited from plot-google-chart-sk
        backgroundColor: style.getPropertyValue('--plot-background-color-sk'),
        colors: [
            style.color
        ]
    };
}
const internals = {
    /**
   * Calculates a hash for a given string.
   *
   * @param {string} traceName - The string to hash.
   * @return {number} The hash value.
   */ getTraceHash: (traceName)=>{
        let hash = 0;
        for(let i = traceName.length - 1; i >= 0; i--){
            // eslint-disable-next-line no-bitwise
            hash = (hash << 5) - hash + traceName.charCodeAt(i);
            // eslint-disable-next-line no-bitwise
            hash |= 0;
        }
        return Math.abs(hash);
    }
};
// We hardcode 'ref' and 'pgo' here because they are special V8 build variants that
// frequently appear together with the base trace. We want to ensure they always
// have distinct colors from the base trace and from each other to make strict comparisons easier.
// ref: Reference build
// pgo: Profile Guided Optimization build
const KNOWN_VARIANT_VALUES = [
    'ref',
    'pgo'
];
/**
 * Calculates the color index for a trace, applying special offsets for
 * known variants (like ref and pgo) if they collide with their base trace or each other.
 *
 * @param {string} traceName - The name of the trace.
 * @return {number} The index into the defaultColors array.
 */ function removeCollisionsForKnownVariants(traceName) {
    // Match any subtest_N=value where value is in KNOWN_VARIANT_VALUES
    const regex = new RegExp(`subtest_(\\d+)=(${KNOWN_VARIANT_VALUES.join('|')})`);
    const match = traceName.match(regex);
    if (!match) {
        return internals.getTraceHash(traceName) % defaultColors.length;
    }
    const subtestId = match[1];
    const currentType = match[2];
    const currentTypeIndex = KNOWN_VARIANT_VALUES.indexOf(currentType);
    // Remove the tag to get base trace.
    // specific regex to remove *this* specific subtest/value pair
    const removeRegex = new RegExp(`,subtest_${subtestId}=${currentType}|subtest_${subtestId}=${currentType},|subtest_${subtestId}=${currentType}`);
    const baseTrace = traceName.replace(removeRegex, '');
    const baseColorIndex = internals.getTraceHash(baseTrace) % defaultColors.length;
    // Calculate indices for all variants (Base + all Known Variants)
    const variantIndices = [];
    // Add base trace index (not used for collision checking against itself in the loop, but needed for set)
    // Actually, we want to check if ANY of them collide.
    const allIndices = new Set();
    allIndices.add(baseColorIndex);
    // Calculate hash for each variant
    for (const variant of KNOWN_VARIANT_VALUES){
        let variantTrace;
        if (variant === currentType) {
            variantTrace = traceName;
        } else {
            // Replace current type with this variant type
            variantTrace = traceName.replace(`subtest_${subtestId}=${currentType}`, `subtest_${subtestId}=${variant}`);
        }
        const index = internals.getTraceHash(variantTrace) % defaultColors.length;
        variantIndices.push(index);
        allIndices.add(index);
    }
    // Check for collisions.
    // We have 1 Base + N Variants. Total N+1 items.
    // If the Set size is less than N+1, there is a collision.
    if (allIndices.size < KNOWN_VARIANT_VALUES.length + 1) {
        // Collision detected!
        // Enforce offsets relative to Base.
        // Variant 0 -> Base + 1
        // Variant 1 -> Base + 2
        // ...
        return (baseColorIndex + currentTypeIndex + 1) % defaultColors.length;
    }
    // No collision, return original hash for this trace
    return internals.getTraceHash(traceName) % defaultColors.length;
}
function getTraceColor(traceName) {
    const index = removeCollisionsForKnownVariants(traceName);
    return defaultColors[index];
}
